import { CONFLICT } from 'http-status-codes';
import { getErrorMessageFromResponse, ToasterException } from 'packages/common/utils';
import workShiftResource from '../resource';
import { INTERVAL_TYPES } from './constants';

export function getWorkShifts({ search, page, pageSize = 10 } = {}) {
  return workShiftResource.getWorkShifts({ search, page, pageSize })
    .then(response => response.data);
}

export function getWorkShift(id) {
  return workShiftResource.getWorkShift(id)
    .then(response => mapWorkShift(response.data));
}

export function createWorkShift(workShift) {
  return workShiftResource.createWorkShift(workShift);
}

export function editWorkShift(id, workShift) {
  return workShiftResource.editWorkShift(id, workShift);
}

export function deleteWorkShift(id) {
  return workShiftResource.deleteWorkShift(id)
    .catch(error => {
      const message = getErrorMessageFromResponse(error);
      const status = error.response.status === CONFLICT ? 'warning' : 'error';

      throw new ToasterException(message, status);
    });
}

export function getIntervalFromWorkShift(workShift) {
  switch (workShift.breakType.name) {
  case 'F':
    return `${workShift.startOfBreak} a ${workShift.endOfBreak}`;

  case 'V':
    return workShift.breakDuration;

  default:
    return null;
  }
}

export function isFixedInterval(intervalType) {
  return intervalType === INTERVAL_TYPES.fixed;
}

export function isVariableInterval(intervalType) {
  return intervalType === INTERVAL_TYPES.variable;
}

function mapWorkShift(response) {
  const intervalType = response.breakType.name;

  return {
    ...response,
    startOfBreak: isFixedInterval(intervalType) ? response.startOfBreak : null,
    endOfBreak: isFixedInterval(intervalType) ? response.endOfBreak : null,
    breakDuration: isVariableInterval(intervalType) ? response.breakDuration : null,
  };
}
